/* eslint-disable react/no-array-index-key */
import { animated, useTransition } from '@react-spring/web';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useRemoveToast } from '../../contexts/ToastContext';
import CloseButton from '../buttons/Close';

import styles from '../../../styles/partials/toasts.module.css';

const propTypes = {
    toasts: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
    className: PropTypes.string,
};

function Toasts({ toasts = null, className }) {
    const removeToast = useRemoveToast();
    const transitions = useTransition(toasts, {
        keys: ({ id }) => id,
        initial: { opacity: 1 },
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: {
            mass: 1,
            tension: 200,
            friction: 20,
            clamp: true,
        },
        trail: 100,
    });
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            {transitions((style, toast) => {
                const { id = null, title = null, description = null, theme = null } = toast || {};
                return id !== null ? (
                    <animated.div
                        key={`toast-${id}`}
                        style={style}
                        className={classNames([styles.toast, { [styles[theme]]: theme !== null }])}
                    >
                        <h6 className={styles.title}>{title}</h6>
                        <p className={styles.description}>{description}</p>
                        <CloseButton className={styles.close} onClick={() => removeToast(id)} />
                    </animated.div>
                ) : null;
            })}
        </div>
    );
}

Toasts.propTypes = propTypes;

export default Toasts;
